export default __webpack_public_path__ + "img/9c62e7caed219178d0910aeaba1b924d.svg";